import '../img/talk1size.png';
function SiteInfo (props) {
    return(
        <>
        <a href="#" onClick={() => props.setState(0)}>
            <div id="siteTitleContainer">
                <h1 id="siteTitle">edsite.black</h1>
            </div>
        </a>
        <div className="bgImage"></div>
        </>
    )
}

export default SiteInfo;